import React, { useState } from 'react';
import { HelpCircle, Send, X } from 'lucide-react';

interface ClarificationOption {
  value: string;
  label: string;
}

interface ClarificationInputProps {
  callId: string;
  question: string;
  options?: ClarificationOption[];
  onSubmit: (callId: string, answer: string) => void;
  onCancel?: (callId: string) => void;
}

export const ClarificationInput: React.FC<ClarificationInputProps> = ({
  callId,
  question,
  options,
  onSubmit,
  onCancel,
}) => {
  const [answer, setAnswer] = useState('');
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  
  const handleSubmit = () => {
    const finalAnswer = selectedOption || answer;
    if (finalAnswer.trim()) {
      onSubmit(callId, finalAnswer);
      setAnswer('');
      setSelectedOption(null);
    }
  };
  
  return (
    <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4 mt-4">
      <div className="flex items-start gap-2 mb-3">
        <HelpCircle size={18} className="text-blue-400 mt-0.5" />
        <div className="text-sm text-gray-200">
          <span className="font-medium text-blue-400">追问：</span>
          {question}
        </div>
      </div>
      
      {options && options.length > 0 ? (
        <div className="flex flex-wrap gap-2 mb-3">
          {options.map((opt, idx) => (
            <button
              key={idx}
              onClick={() => setSelectedOption(opt.value)}
              className={`px-3 py-1.5 text-sm rounded-lg border transition-colors ${
                selectedOption === opt.value
                  ? 'bg-blue-500/30 border-blue-500 text-blue-300'
                  : 'bg-transparent border-gray-600 text-gray-400 hover:border-gray-500'
              }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      ) : (
        <input
          type="text"
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          placeholder="请输入您的回答..."
          className="w-full bg-black/30 border border-gray-600 rounded-lg px-3 py-2 text-sm text-gray-200 placeholder-gray-500 focus:border-blue-500 focus:outline-none mb-3"
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleSubmit();
          }}
        />
      )}
      
      <div className="flex items-center gap-2">
        <button
          onClick={handleSubmit}
          disabled={!selectedOption && !answer.trim()}
          className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-500 hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed text-white text-sm rounded-lg transition-colors"
        >
          <Send size={14} />
          发送
        </button>
        {onCancel && (
          <button
            onClick={() => onCancel(callId)}
            className="flex items-center gap-1.5 px-3 py-1.5 text-gray-400 hover:text-gray-300 text-sm rounded-lg transition-colors"
          >
            <X size={14} />
            跳过
          </button>
        )}
      </div>
    </div>
  );
};

export default ClarificationInput;
